import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { MarcaRequest, Response } from './Types';

class MarcaController {
  public static async Listar(request: MarcaRequest): Promise<Response> {
    try {
      console.log('Controller Marca Listar');
      console.log(request);

      const response = await Api.post('api/marca/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(MarcaId: number): Promise<Response> {
    try {
      console.log('Controller Marca Listar Unico');
      console.log(MarcaId);

      const response = await Api.get(`api/marca/ListarUnico/${MarcaId}`);

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: MarcaRequest): Promise<Response> {
    try {
      console.log('Controller Marca Adicionar');
      console.log(request);

      const response = await Api.post(`api/marca/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: MarcaRequest): Promise<Response> {
    try {
      console.log('Controller Marca Atualizar');
      console.log(request);

      const response = await Api.put(`api/marca/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: MarcaRequest): Promise<Response> {
    try {
      console.log('Controller Marca Excluir');
      console.log(request);

      const response = await Api.put(`api/marca/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default MarcaController;
